import { useTranslation } from "react-i18next";
import { usePwaInstall } from "@/hooks/use-pwa-install";

export function PwaInstallBanner() {
  const { t } = useTranslation();
  const { canInstall, triggerInstall, dismissInstall } = usePwaInstall();

  if (!canInstall) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-0 right-0 z-50 flex justify-center px-4 transition-all duration-300 ease-out animate-in fade-in slide-in-from-bottom-2">
      <div className="w-full max-w-sm bg-primary dark:bg-card rounded-xl shadow-lg p-4 flex items-center justify-between gap-3">
        <p className="text-sm text-white flex-1">
          {t("pwa.installMessage")}
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={dismissInstall}
            className="text-xs text-muted-foreground hover:text-primary-foreground transition-colors"
          >
            {t("pwa.notNow")}
          </button>
          <button
            onClick={triggerInstall}
            className="text-xs font-medium bg-primary text-primary-foreground px-3 py-1.5 rounded-lg hover:opacity-90 transition-opacity"
          >
            {t("pwa.install")}
          </button>
        </div>
      </div>
    </div>
  );
}
